import React from "react";
import { Field, Fields, getFormValues } from "redux-form";
import FileUpload from "../../../Shared/Component/Forms/FileUpload";
import InputText from "../../../Shared/Component/Forms/InputText";
import InputTextTranslation from "../../../Shared/Component/Forms/InputTextTranslation";
import SelectDropdown from "../../../Shared/Component/Forms/SelectDropdown";
import MultiSelectDropdown from "../../../Shared/Component/Forms/MultiSelectDropdown";
import InputCalendar from "../../../Shared/Component/Forms/InputCalendar";
import UserRoles from "../../../Shared/Constant/UserRoles";
import { useSelector } from "react-redux";
import { validateReduxForm } from "../../../Shared/Component/Forms/MasterValidation";
import PasswordField from "../../../Shared/Component/Forms/PasswordField";

const renderFields = (props) => {
  const { type, placeholder, disabled, required, label, mode } = props;
  const firstField = props[props.names[0]];
  const secondField = props[props.names[1]];
  const inputTextMeta = {
    touched: firstField.meta.touched,
    error: validateReduxForm(
      type,
      firstField.input.value,
      label,
      required,
      false,
      mode
    ),
  };
  const firstInput = firstField.input;
  const translatedTextMeta = {
    touched: secondField.meta.touched,
    error: validateReduxForm(
      type,
      secondField.input.value,
      label,
      required,
      true,
      mode
    ),
  };
  const secondInput = secondField.input;

  return (
    <InputTextTranslation
      inputText={firstField.input.value}
      firstInput={firstInput}
      inputTextMeta={inputTextMeta}
      translatedText={secondField.input.value}
      secondInput={secondInput}
      translatedTextMeta={translatedTextMeta}
      asterisk={required && "*"}
      disabled={disabled}
      required={required}
      label={label}
      type={type}
      placeholder={placeholder}
      onChangeInputText={firstField.input.onChange}
      onChangeTranslatedText={secondField.input.onChange}
    />
  );
};
const renderField = (props) => {
  const {
    input,
    type,
    dropdownOptions = { isLoading: false, options: [] },
    placeholder,
    disabled,
    required,
    label,
    showApproveRejectBtn,
    containsValues,
    initialValues = { status: "" },
    formValues,
    mode,
    meta: {
      touched,
      error = validateReduxForm(
        props.type,
        props.input.value,
        props.label,
        props.required,
        false,
        props.mode
      ),
    },
    masterType,
  } = props;
  const { isLoading, options } = dropdownOptions;
  const currentRole = sessionStorage.getItem("userRole");
  const isSuperAdminShown =
    currentRole === UserRoles.SUPERADMIN && initialValues.status === "Invalid";

  if (!props.translate && type === "text") {
    return (
      <InputText
        translate={props.translate}
        value={input.value}
        disabled={disabled}
        asterisk={required && "*"}
        required={required}
        label={label}
        type={type}
        input={input}
        meta={{
          touched,
          error,
        }}
        onChange={input.onChange}
        mode={mode}
      />
    );
  } else if (type === "calendar") {
    return (
      <InputCalendar
        disabled={disabled}
        asterisk={required && "*"}
        required={required}
        label={label}
        input={input}
        placeholder={placeholder}
        meta={{
          touched,
          error,
        }}
      />
    );
  } else if (type === "password") {
    return (
      <PasswordField
        translate={props.translate}
        value={input.value}
        type={type}
        input={input}
        disabled={disabled}
        required={required}
        asterisk={required && "*"}
        label={label}
        meta={{
          touched,
          error: error,
        }}
        onChange={input.onChange}
      />
    );
  } else if (type === "multiselect") {
    return (
      <MultiSelectDropdown
        disabled={disabled}
        asterisk={required && "*"}
        required={required}
        label={label}
        input={input}
        placeholder={placeholder}
        options={options}
        meta={{
          touched,
          error,
        }}
        mode={mode}
        roleName={formValues.roleName}
        masterType={masterType}
      />
    );
  } else if (type === "dropdown") {
    return (
      <SelectDropdown
        disabled={disabled}
        asterisk={required && "*"}
        required={required}
        label={label}
        input={input}
        placeholder={placeholder}
        isLoading={isLoading}
        options={options}
        change={props.change}
        optionLabel={props.optionName}
        containsValues={containsValues}
        meta={{
          touched,
          error,
        }}
        mode={mode}
        roleName={formValues.roleName}
        masterType={masterType}
      />
    );
  } else if (type === "file") {
    return (
      <FileUpload
        value={input.value}
        disabled={disabled}
        asterisk={required && "*"}
        required={required}
        label={label}
        type={type}
        input={input}
        placeholder={placeholder}
        isSuperAdminShown={isSuperAdminShown}
        showApproveRejectBtn={showApproveRejectBtn}
        meta={{
          touched,
          error,
        }}
      />
    );
  } else {
    return <div>Type not supported.</div>;
  }
};

export const FormField = (props) => {
  const {
    name,
    type,
    dropdownOptions,
    initialValues,
    whenVisible,
    formName,
    confirmPasswordFieldName,
    mode,
  } = props;
  const formValues = useSelector((state) => getFormValues(formName)(state));

  let flag = true;

  if (whenVisible && whenVisible.length > 0) {
    whenVisible.forEach((element) => {
      const selectedValue = formValues[element.name];
      if (!element.values.includes(selectedValue)) {
        flag = false;
      }
    });
  }
  if (name === "talukaId" && mode === "Update") {
    if (formValues.roleName === UserRoles.PHCMO && formValues.lgbId === 1) {
      flag = true;
    }else if (formValues.roleName === UserRoles.UPHCMO && formValues.lgbId !== 1){
      flag = false;
    }
  }
  if (name === "talukaId" && mode === "Add") {
     if (formValues.roleName === UserRoles.UPHCMO && formValues.lgbId !== 1){
      flag = false;
    }
  }
  if (!flag) {
    return null;
  }
  const renderFieldWithProps = (fieldProps) =>
    renderField({
      ...fieldProps,
      formValues,
      confirmPasswordFieldName,
      mode,
    });
  return (
    <div
      className={
        type === "file"
          ? "col-12 flex pt-5"
          : "col-12 md:col-6 lg:col-3 flex-column flex"
      }
    >
      {props.translate ? (
        <Fields
          {...props}
          names={[name, name + 1]}
          type={type}
          component={renderFields}
        />
      ) : (
        <Field
          {...props}
          name={name}
          type={type}
          dropdownOptions={dropdownOptions}
          component={renderFieldWithProps}
          initialValues={initialValues}
        />
      )}
    </div>
  );
};
